import { Grid, styled } from "@mui/material";
import { IStyledGridProps } from "./types";

const StyledGrid = styled(Grid)<IStyledGridProps>(({ theme, container}) => ({
    boxSizing: "border-box",
}))

export {StyledGrid}